module.exports = __webpack_public_path__ + "static/img/activity-20210705.d475c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20210705.png
// module id = UL3c
// module chunks = 0